export default __webpack_public_path__ + "static/media/Design2Debug.df6098b7.jpg";